import { membersBaseURL, clearObject } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params, config = {}) =>
  window.axios.post(url, params, { baseURL, ...config });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = url => window.axios.get(url, { baseURL });

export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();

      return _get(`/courses/categories/product/${params.product_id}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setCategories", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      _post("/courses/categories", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/courses/categories/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  changeStatus(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/courses/categories/${params.id}`, { is_active: !params.is_active })
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/courses/categories/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  reorder(context, categories) {
    return new Promise((resolve, reject) => {
      _put(`/courses/categories/reorder`, { categories })
        .then(resolve)
        .catch(reject);
    });
  }
};
